import { Element, useNode } from "@craftjs/core";
import * as React from "react";
import { Actions } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import Image from "@/components/editor/primitives/image/image-component";
import RichText from "@/components/editor/primitives/rich-text";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";
import { IMAGE_UPLOAD_TYPES } from "@/features/analytics";

import {
  BackgroundWrapper,
  ButtonWrapper,
  DescriptionWrapper,
  HeadingWrapper,
  ImageWrapper,
  LeftColumn,
  PaddingWrapper,
  RightColumn,
  Wrapper,
} from "./about-details-component-styles";
import {
  DEFAULT_ABOUT_DETAILS_CTA_TEXT,
  DEFAULT_ABOUT_DETAILS_DESCRIPTION,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_1,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_2,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_3,
  DEFAULT_ABOUT_DETAILS_LIST_ITEM_4,
  DEFAULT_ABOUT_DETAILS_SUBTITLE,
} from "./constants";

export default function AboutDetails() {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BackgroundWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <Wrapper>
            <LeftColumn>
              <HeadingWrapper>
                <Element
                  id="subtitle"
                  is={RichText}
                  text={`<h3>${DEFAULT_ABOUT_DETAILS_SUBTITLE}</h3>`}
                />
              </HeadingWrapper>
              <ButtonWrapper>
                <Element
                  id="cta-text"
                  is={Button}
                  text={DEFAULT_ABOUT_DETAILS_CTA_TEXT}
                  action={{ kind: Actions.TicketSelector }}
                />
              </ButtonWrapper>
              <ImageWrapper>
                <Element
                  id="about-details-image"
                  is={Image}
                  src="/canvas/nolan/images/about-details-placeholder.ab938793.jpg"
                  blockType={IMAGE_UPLOAD_TYPES.ABOUT_DETAILS}
                />
              </ImageWrapper>
            </LeftColumn>
            <RightColumn>
              <DescriptionWrapper>
                <Element
                  id="description"
                  is={RichText}
                  text={`
                    <p>${DEFAULT_ABOUT_DETAILS_DESCRIPTION}</p>
                    <ul>
                      <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_1}</li>
                      <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_2}</li>
                      <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_3}</li>
                      <li>${DEFAULT_ABOUT_DETAILS_LIST_ITEM_4}</li>
                    </ul>
                  `}
                />
              </DescriptionWrapper>
            </RightColumn>
          </Wrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BackgroundWrapper>
  );
}

AboutDetails.craft = {
  custom: {
    displayName: "About Details",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
